export function parseCookies(input = '') {
    if (!input) {
        return {};
    }
    return Object.fromEntries(input.split(/; */).map((cookie) => cookie.split('=')));
}
